import style from "./icon.module.css";

export const LoIcon = () => {
  return (
    <svg
      className={style.icon}
      fill="currentColor"
      viewBox="0 0 680 450" 
      xmlns="http://www.w3.org/2000/svg"
    >

<g transform="translate(0.000000,450.000000) scale(0.100000,-0.100000)" stroke="none">
<path d="M4644 4289 c-555 -49 -1023 -346 -1288 -817 -113 -201 -187 -424
-227 -687 -26 -168 -31 -545 -10 -710 30 -241 87 -443 175 -630 237 -499 628
-808 1165 -922 116 -25 145 -27 361 -27 217 0 244 2 361 27 520 111 915 413
1144 875 140 282 201 543 212 912 13 428 -47 744 -203 1070 -113 235 -276 436
-480 589 -328 246 -761 360 -1210 320z m362 -720 c89 -22 212 -84 281 -141
117 -96 226 -272 276 -448 53 -183 62 -263 62 -575 0 -194 -4 -318 -13 -375
-44 -277 -138 -485 -287 -635 -88 -89 -190 -147 -315 -182 -102 -27 -293 -25
-390 5 -130 41 -226 98 -310 182 -151 153 -235 347 -282 650 -17 114 -17 574
0 695 54 375 211 643 445 760 186 93 343 112 533 64z"/>
<path d="M760 2395 l0 -1845 1120 0 1120 0 0 360 0 360 -675 0 -675 0 0 1485
0 1485 -445 0 -445 0 0 -1845z"/>
</g>
    </svg>
  );
};
